import React, { useState, useEffect } from 'react';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';

import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { convertToTimezoneFormat } from 'utils/utility_functions/timezone';

function DateRangeFilter() {
  const { fileManagerFilters, setSelectedRows, setFileManagerFilters } = useFileManagerContext();
  const userContext = useUserDetailsContext();
  const [dateRange, setDateRange] = useState(null);

  // Reset local dateRange state when global filters are reset
  useEffect(() => {
    // If both start_date and end_date are empty (reset), clear the local dateRange
    if (!fileManagerFilters.start_date && !fileManagerFilters.end_date) {
      setDateRange(null);
    }
  }, [fileManagerFilters.start_date, fileManagerFilters.end_date]);

  const handleDateRangeChange = (dates) => {
    setDateRange(dates);

    if (dates && dates.length === 2 && dates[0] && dates[1]) {
      // Format dates for backend using user's timezone
      const startDate = convertToTimezoneFormat(moment(dates[0]).startOf('day'), userContext?.userDetails?.timezone);
      const endDate = convertToTimezoneFormat(moment(dates[1]).endOf('day'), userContext?.userDetails?.timezone);

      // Update both start_date and end_date in filters simultaneously
      setFileManagerFilters((prevValues) => ({
        ...prevValues,
        start_date: startDate,
        end_date: endDate,
      }));
      setSelectedRows([]);
    } else {
      // Clear date filters when no valid range is selected
      setFileManagerFilters((prevValues) => ({
        ...prevValues,
        start_date: '',
        end_date: '',
      }));
    }
  };

  return (
    <Calendar
      value={dateRange}
      onChange={(e) => handleDateRangeChange(e.value)}
      selectionMode="range"
      placeholder="Select Date Range"
      className="file-manager-select w-100"
      dateFormat="mm/dd/yy"
      readOnlyInput
    />
  );
}

export default DateRangeFilter;
